<template>
  <h3 class="p-6 text-lg font-semibold text-[#f8f7f2]">Formação Acadêmica</h3>
  <ol class="ml-8 relative border-l border-[#f8f7f2] dark:border[#f8f7f2]">
    <li class="mb-10 ml-4">
      <div
        class="absolute w-3 h-3 bg-[#f8f7f2] rounded-full mt-1.5 -left-1.5 border border-white dark:border-[#f8f7f2] dark:bg-[#f8f7f2]"
      ></div>
      <time class="mb-1 text-sm font-normal leading-none text-[#f8f7f2]"
        >Instituto Federal Catarinense</time
      >
      <h3 class="text-lg font-semibold text-[#f8f7f2]">
        Bacharelado em Sistemas de Informação | 2023 - 2026
      </h3>
      <p class="text-base font-normal text-gray-500 dark:text-gray-400">
        Bacharelado em Sistemas de Informação, com ênfase em Desenvolvimento de
        Sistemas.
      </p>
    </li>
    <li class="ml-4">
      <div
        class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-[#f8f7f2] dark:bg-[#f8f7f2]"
      ></div>
      <time class="mb-1 text-sm font-normal leading-none text-[#f8f7f2]"
        >Instituto Federal Catarinense</time
      >
      <h3 class="text-lg font-semibold text-[#f8f7f2]">
        Técnico em Informática | 2020 - 2022
      </h3>
      <p class="text-base font-normal text-gray-500 dark:text-gray-400">
        Técnico em Informática, com ênfase em Desenvolvimento de Sistemas.
      </p>
    </li>
  </ol>
</template>

<script>
export default {};
</script>

<style>
</style>